import { Component, input } from '@angular/core';
import { ICategory, DoodProductModel } from '@core/models/product.model';
import { CategoryKeys } from '@config/keys/category.keys';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { ContentBuilderColorValue } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ProductPushV2AtomHoverColors } from '@shared/interfaces/product-hover-colors.interface';
import { InterfaceToInputs } from '@shared/utils/types/interface-to-inputs';
import { ProductPushListAtomComponent } from '../product-push-list-atom/product-push-list-atom.component';
import { ProductColorOverrides } from '@shared/interfaces/product-category-color-overrides.interface';

import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product';
@Component({
  selector: 'app-product-category-cards-without-name-atom',
  templateUrl: './product-category-cards-without-name-atom.component.html',
  imports: [ProductPushListAtomComponent],
})
export class ProductCategoryCardsWithoutNameAtomComponent implements InterfaceToInputs<
  ProductColorOverrides,
  { required: true }
> {
  readonly displayContext = input('shop_page');
  readonly category = input.required<ICategory>();
  readonly products = input.required<DoodProductModel[]>();
  readonly tagColors = input.required<ContentBuilderFieldColors>();
  readonly categoryNameColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly categoryDescriptionColor = input<ContentBuilderColorValue>({
    value: 'neutral-600',
    type: ColorFieldTypesValues.Palette,
  });
  readonly highlightCategoryNameColor = input<ContentBuilderColorValue>({
    type: ColorFieldTypesValues.Default,
    value: '',
  });
  readonly highlightCategoryBackgroundColor = input<ContentBuilderColorValue>({
    value: 'neutral-600',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productNameColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productDescriptionColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productPriceColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productImagePlaceholderColor = input<ContentBuilderColorValue>({
    value: 'neutral-50',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productBorderColor = input<ContentBuilderColorValue>({
    value: 'neutral-100',
    type: ColorFieldTypesValues.Palette,
  });
  readonly productBackgroundColor = input<ContentBuilderColorValue>({
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  });
  readonly productHoverColors = input<ProductPushV2AtomHoverColors | undefined>(undefined);

  categoryKeys = CategoryKeys;

  private readonly store = inject(Store);

  protected requestGoToProduct(product: DoodProductModel): void {
    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: product.shop_id,
        productOrigin: {
          channel: 'catalog',
          reference: `category_${this.category().id}`,
        },
      }),
    );
  }
}
